﻿(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyNumbersOnly', function Map() {
            return {
                require: 'ngModel',
                link: function ($scope, $element, $attrs, ngModelCtrl) {
                    function userInput(text) {
                        if (text) {
                            var transformedInput = text.replace(/[^0-9]/g, '');
                            var maxLength = $attrs.maxDigits;
                            if (maxLength && transformedInput.length > maxLength) {
                                transformedInput = transformedInput.substring(0, maxLength);
                            }
                            if (transformedInput !== text) {
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        }
                        return undefined;
                    }
                    ngModelCtrl.$parsers.push(userInput);
                }
            };
        });
})(window.angular);